import { render, staticRenderFns } from "./ModalSelectLabProcedure.vue?vue&type=template&id=50bc68de&"
import script from "./ModalSelectLabProcedure.vue?vue&type=script&lang=js&"
export * from "./ModalSelectLabProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports